export function isFlagSet(obj, flag) {
    return (obj.setting_register & flag) != 0;
}
export function setFlag(obj, flag, set) {
    return {
        ...obj,
        setting_register: (obj.setting_register & ~flag) | (set ? flag : 0),
    };
}
